<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div style="padding-top: 10px;padding-bottom: 10px;">
        共有{{ total }}条动态待审核
      </div>
    </div>

    <div class="infinite-list-wrapper" style="overflow:auto">
      <ul v-infinite-scroll="getDynamicList"
          infinite-scroll-disabled="disabled">
        <div v-for="(dynamic, index) in this.dynamicList" :key="index">
          <el-container style="padding-right:30px;">
            <el-header :height="40" style="text-align: left;padding-top: 10px;">
              <el-row>
                <el-col :span="2">
                  <!-- 头像-->
                  <div class="avatar-border">
                    <el-avatar v-if="dynamic.anonymity===0" :src="dynamic.avatarUrl"></el-avatar>
                    <el-avatar v-if="dynamic.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                    <div v-if="dynamic.anonymity===0">
                      <div v-if="dynamic.utype===2"
                           class="badge-gender" style="background-color:#FF6E40;">v
                      </div>
                      <div v-if="dynamic.utype===1"
                           class="badge-gender" style="background-color:#3688FF; ">v
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <!--昵称 时间 学校-->
                  <div style="display: flow">
                    <div class="title-info">
                      {{ dynamic.nickname }}
                      <span v-if="dynamic.stick===1"
                            style="color:#EF5350;padding-left: 5px;">
                        [置顶]
                      </span>
                      <div style="font-size: 13px; ">
                        <div style="float: left;">
                          {{ dynamic.transformDate }}
                        </div>
                        <div style="color: #42A5F5; float: left; padding-left: 5px;">
                          {{ dynamic.schoolName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-header>
            <el-main style="text-align: left;padding-top: 10px;padding-bottom: 10px;">
              <div @click="dynamicDetail(dynamic.id)">
                <span v-if="dynamic.type!==1" style="word-break:break-word;" v-html='dynamic.content'></span>
                <div v-if="dynamic.type===1">
                  发布了文章
                  <div style="background-color: #EEEEEE;border-radius: 2px;padding: 5px;overflow: hidden;text-overflow:ellipsis;
            white-space: nowrap;">
                    <i class="el-icon-link el-icon--left"
                       style="border-right: #8a8f97 solid 2px;padding-right: 5px"></i>
                    <span style="font-size: 13px;">
                    {{ JSON.parse(dynamic.content)[JSON.parse(dynamic.content).length - 1].content }}
                  </span>
                  </div>
                </div>
                <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===0" style="padding-top: 10px;">
                  <div v-if="dynamic.dynamicImgList.length!==4" style="width: 500px;display: inline;padding-left:5px;"
                       v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                    <el-image
                        style="width: 150px; height: 150px"
                        fit="cover"
                        :src="img.imgUrl"
                        :preview-src-list="imgList(dynamic.dynamicImgList)">
                    </el-image>
                  </div>
                  <div v-if="dynamic.dynamicImgList.length===4 && dynamic.type===0"
                       style="width: 500px;display: inline;padding-left:5px;"
                       v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                    <el-image
                        style="width: 160px; height: 160px"
                        fit="cover"
                        :src="img.imgUrl"
                        :preview-src-list="imgList(dynamic.dynamicImgList)">
                    </el-image>
                  </div>
                </div>
                <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===2">
                  <Video v-bind:videoUrl="dynamic.dynamicImgList[0].imgUrl" :status="true"></Video>
                </div>
                <div v-if="dynamic.type===3" style="color: #E6A23C;">
                  投票内容请在移动端查看
                </div>
                <!-- 圈子标签 -->
                <div style="padding-top: 10px;padding-bottom: 10px;" v-if="dynamic.circleType!==0">
                  <!-- <gui-tags text="#边框标签" bgClass="gui-bg-white" color="#f75f00"
                      :width="0" :lineHeight="1.5" :size="28" :borderRadius="50" borderColor="#FF0035"></gui-tags> -->
                  <div v-if="dynamic.circles!==null"
                       style="float: left;display:initial;height: 20px; border: #2196F3 solid 1px; font-size: 13px;color:#2196F3 ; border-radius: 50px;padding-left: 7px;padding-right: 7px;">
                    {{ dynamic.circles.title }}
                  </div>
                </div>
              </div>
            </el-main>
            <el-footer height="50"
                       style="text-align: center;padding-top: 5px;padding-bottom: 5px; border-top:solid #F6F7F8 2px;">
              <el-row>
                <el-col :span="8">
                  {{ dynamic.praiseCount }} 赞
                </el-col>
                <el-col :span="8">{{ dynamic.commentCount }} 评论</el-col>
                <el-col :span="8">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="pass(dynamic,index)">通过
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="rejectShow(dynamic,index)">不予通过</el-dropdown-item>

                    </el-dropdown-menu>
                  </el-dropdown>
                  <!--                  <el-popover-->
                  <!--                      placement="bottom"-->
                  <!--                      width="150"-->
                  <!--                      trigger="click">-->
                  <!--                    <el-button type="success" size="mini" plain v-if="dynamic.stick===0" @click="stick(dynamic,index)">-->
                  <!--                      置顶-->
                  <!--                    </el-button>-->
                  <!--                    <el-button type="success" size="mini" plain v-if="dynamic.stick===1"-->
                  <!--                               @click="unstick(dynamic,index)">取消置顶-->
                  <!--                    </el-button>-->
                  <!--                    <el-popover-->
                  <!--                        placement="top"-->
                  <!--                        width="160"-->
                  <!--                        v-model="visible">-->
                  <!--                      <p>这是一段内容这是一段内容确定删除吗？</p>-->
                  <!--                      <div style="text-align: right; margin: 0">-->
                  <!--                        <el-button size="mini" type="text" @click="visible = false">取消</el-button>-->
                  <!--                        <el-button type="primary" size="mini" @click="visible = false">确定</el-button>-->
                  <!--                      </div>-->
                  <!--                      <el-button type="danger" size="mini" plain slot="reference">删除</el-button>-->

                  <!--                    </el-popover>-->
                  <!--                    <i class="el-icon-more" slot="reference"></i>-->
                  <!--                  </el-popover>-->

                </el-col>
              </el-row>
            </el-footer>
          </el-container>
          <div class="line"></div>
        </div>
      </ul>
      <p v-if="loading">加载中...</p>
      <p v-if="empty">没有更多了</p>
    </div>
    <el-dialog
        v-loading="dynamicLoading"
        :visible.sync="DialogVisible"
        width="600px" style="min-width: 350px">
      <div v-if="DialogVisible">

        <el-container style="padding-right:30px;margin-left: 44px">
          <el-header height="40" style="text-align: left;padding-top: 10px;">
            <el-row>
              <el-col :span="2">
                <!-- 头像-->
                <div class="avatar-border">
                  <el-avatar v-if="dynamic.anonymity===0" :src="dynamic.avatarUrl"></el-avatar>
                  <el-avatar v-if="dynamic.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                  <div v-if="dynamic.anonymity===0">
                    <div v-if="dynamic.utype===2"
                         class="badge-gender" style="background-color:#FF6E40;">v
                    </div>
                    <div v-if="dynamic.utype===1"
                         class="badge-gender" style="background-color:#3688FF; ">v
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <!--昵称 时间 学校-->
                <div style="display: flow">
                  <div class="title-info">
                    {{ dynamic.nickname }}
                    <span v-if="dynamic.stick===1"
                          style="color:#EF5350;padding-left: 5px;">
                        [置顶]
                      </span>
                    <div style="font-size: 13px; ">
                      <div style="float: left;">
                        {{ dynamic.transformDate }}
                      </div>
                      <div style="color: #42A5F5; float: left; padding-left: 5px;">
                        {{ dynamic.schoolName }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-header>
          <el-main style="text-align: left;padding-top: 10px;padding-bottom: 10px;">
            <span v-if="dynamic.type!==1" style="word-break:break-word;" v-html='dynamic.content'></span>
            <div v-if="dynamic.type===1">
              <span>{{ JSON.parse(dynamic.content)[JSON.parse(dynamic.content).length - 1].content }}</span>
              <span style="word-break:break-word;" v-html='jsonToHtml(dynamic.content)'></span>
            </div>
            <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===0" style="padding-top: 10px;">
              <div v-if="dynamic.dynamicImgList.length!==4" style="width: 500px;display: inline;padding-left:5px;"
                   v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                <el-image
                    style="width: 150px; height: 150px"
                    fit="cover"
                    :src="img.imgUrl"
                    :preview-src-list="imgList(dynamic.dynamicImgList)">
                </el-image>
              </div>
              <div v-if="dynamic.dynamicImgList.length===4 && dynamic.type===0"
                   style="width: 500px;display: inline;padding-left:5px;"
                   v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                <el-image
                    style="width: 160px; height: 160px"
                    fit="cover"
                    :src="img.imgUrl"
                    :preview-src-list="imgList(dynamic.dynamicImgList)">
                </el-image>
              </div>
            </div>
            <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===2">
              <Video v-bind:videoUrl="dynamic.dynamicImgList[0].imgUrl" :status="true"></Video>
            </div>
            <div v-if="dynamic.type===3" style="color: #E6A23C;">
              投票内容请在移动端查看
            </div>
            <!-- 圈子标签 -->
            <div style="padding-top: 10px;padding-bottom: 10px;" v-if="dynamic.circleType!==0">
              <!-- <gui-tags text="#边框标签" bgClass="gui-bg-white" color="#f75f00"
                  :width="0" :lineHeight="1.5" :size="28" :borderRadius="50" borderColor="#FF0035"></gui-tags> -->
              <div v-if="dynamic.circles!==null"
                   style="float: left;display:initial;height: 20px; border: #2196F3 solid 1px; font-size: 13px;color:#2196F3 ; border-radius: 50px;padding-left: 7px;padding-right: 7px;">
                {{ dynamic.circles.title }}
              </div>
            </div>
          </el-main>
          <el-footer height="50"
                     style="text-align: center;padding-top: 5px;padding-bottom: 5px; border-top:solid #F6F7F8 2px;">
            <el-row>
              <el-col :span="8">
                {{ dynamic.praiseCount }} 赞
              </el-col>
              <el-col :span="8">{{ dynamic.commentCount }} 评论</el-col>
              <el-col :span="8">

              </el-col>
            </el-row>
          </el-footer>
        </el-container>
        <div class="line"></div>
        <div style="text-align: left; border-bottom: #409EFF solid 2px; padding-top: 10px;width: 30px">
          评论
        </div>
        <!--        <div style="text-align: center;padding-top: 10px" v-if="commentList.length===0">-->
        <!--          暂无评论-->
        <!--        </div>-->
        <!--  start -->
        <comment-list :dynamic-id="dynamicId" :is-delete="true"></comment-list>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="DialogVisible = false">取 消</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="请输入驳回原因"
        :visible.sync="rejectDialog"
        :close-on-click-modal="false"
        :show-close="false"
        width="30%">
      <el-input
          placeholder="请输入原因"
          v-model="audit.reason">
      </el-input>

      <span slot="footer" class="dialog-footer">
    <el-button @click="closeReject()">取 消</el-button>
    <el-button type="primary" @click="reject()">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Video from '../../../components/preview/VideoPreview'
import commentList from '../../../components/commentList/commentList'

export default {
  name: 'Dynamic',
  data () {
    return {
      dynamicList: [],
      commentList: [],
      currentPage: 1,
      size: 10,
      loading: false,
      empty: false,
      apiLoading: false,
      count: 10,
      DialogVisible: false,
      dynamic: null,
      dynamicLoading: false,
      total: 0,
      dynamicId: 0,
      commentCurrentPage: 1,
      commentSize: 20,
      commentEmpty: false,
      commentLoading: false,
      visible: false,
      audit: {
        id: 0,
        reason: ''
      },
      index:-1,
      rejectDialog: false
    }
  },
  components: {
    Video,
    commentList
  },
  mounted () {
    // this.getDynamicList()
  },
  computed: {
    noMore () {
      return this.empty
      //return this.count >= 20
    },
    disabled () {
      console.log(this.loading || this.noMore)
      return this.loading || this.noMore
      //return this.loading || this.empty
    },

  },
  methods: {
    videoUrl (url) {
      let file
      file = {
        url: url
      }
      console.log(file)
      return file
    },
    imgList (imgList) {
      var imgs = []
      for (var i = 0; i < imgList.length; i++) {
        imgs[i] = imgList[i].imgUrl
      }
      return imgs
    },
    getDynamicList: function () {
      var dynamic = []
      if (this.empty === false) {
        this.loading = true
        this.postRequest('/dynamic/audit/dynamicList?currentPage=' + this.currentPage + '&size=' + this.size)
            .then(
                resp => {
                  this.loading = false
                  if (resp) {
                    dynamic = resp.data
                    // if (dynamic.length > 0) {
                    //   dynamic.forEach(data => {
                    //     if (data.type === 1) {
                    //       data.content = this.jsonToHtml(data.content)
                    //     }
                    //   })
                    // }
                    this.dynamicList = this.dynamicList.concat(dynamic)
                    this.total = resp.total
                    this.currentPage++
                    if (resp.data.length === 0) {
                      this.empty = true
                    }
                  }
                })
      }
    },
    dynamicDetail (id) {
      this.DialogVisible = true
      this.dynamic = null
      this.dynamicLoading = true
      this.dynamicId = id
      // this.getCommentList(id)
      this.postRequest('/dynamic/app/detail?id=' + id)
          .then(
              resp => {
                this.isLoad = true
                if (resp) {
                  //console.log(resp)
                  this.dynamicLoading = false
                  this.dynamic = resp
                  // this.dynamic.content = this.jsonToHtml(resp.content)
                }
              })
    },
    jsonToHtml (content) {
      content = JSON.parse(content)
      console.log(content[1].content)
      var html = ''
      if (content.length > 0) {
        content.forEach(item => {
          switch (item.type) {
            case 'h3':
              html = html.concat('<h3>' + item.content + '</h3>')
              break
            case 'text':
              html = html.concat('<p>' + item.content + '</p>')
              break

            case 'txt':
              html = html.concat('<p>' + item.content + '</p>')
              break
            case 'code':
              html = html.concat('<pre>' + item.content + '</pre>')
              break
            case 'center':
              html = html.concat('<div style="text-align: center;">' + item.content + '</div>')
              break
            case 'quote':
              html = html.concat('<blockquote>' + item.content + '</blockquote>')
              break
            case 'strong':
              html = html.concat('<strong>' + item.content + '</strong>')
              break
            case 'link':
              html = html.concat('<p><a href="\'' + item.content + '" target="_blank">' + item['content'] + '</a><p>')
              break
            case 'spline':
              html = html.concat('<p><hr /><p>')
              break
            case 'img':
              html = html.concat('<img src=' + '"' + item.content + '" style="width:400px;"/>')
              break
          }
        })
      }
      return html
    },
    pass (dynamic,index) {
      this.$confirm('此操作将审核通过此条动态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequest('/dynamic/audit/pass/' + dynamic.id).then(resp => {
          if (resp) {
            this.dynamicList.splice(index, 1)
            this.total = this.total -1
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    rejectShow (dynamic,index) {
      this.audit.id = dynamic.id
      this.index = index
      this.rejectDialog = true
    },
    closeReject(){
      this.audit ={
        id :0,
        reason:''
      }
      this.index = -1
      this.rejectDialog = false
    },
    reject () {
      if (this.audit.reason === '') {
        this.$message({
          message: '驳回原因不能为空',
          type: 'warning'
        })
        return
      }
      this.$confirm('此操作将此条动态驳回, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequest('/dynamic/audit/reject', this.audit).then(resp => {
          if (resp) {
            this.audit = {
              id: 0,
              reason: ''
            }
            this.rejectDialog = false
            this.dynamicList.splice(this.index, 1)
            this.total = this.total -1
            this.index = -1
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
  }
}
</script>

<style scoped>
.infinite-list-wrapper {
  width: 600px;
  height: 700px;
  /*border: 1px solid #eee;*/
}

.comment-infinite-list-wrapper {
  /*width: 600px;*/
  height: 400px;
  border: 1px solid #eee;
}

.avatar-border {
  width: 60px;
}

.title-info {
  /*width: 400px;*/
  text-align: left;
  word-break: break-word;
  padding-left: 5px;
}

/* 分割线 */
.line {
  height: 10px;
  background-color: #F6F7F8;
}

/* 徽章 */
.badge-gender {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  text-align: center;
  font-size: 15px;
  line-height: 15px;
  position: absolute;
  left: 25px;
  top: 23px;
  z-index: 1;
  border: #FFFFFF solid 2px;
  color: #FFFFFF;
}
</style>
